import React from 'react';
import { ConditionDefinition } from '../types';
import { BooleanCondition } from './BooleanCondition';
import { NctIdListCondition } from './NctIdListCondition';

interface ConditionFieldProps {
  definition: ConditionDefinition;
  value: any;
  onChange: (value: any) => void;
}

export const ConditionField: React.FC<ConditionFieldProps> = ({
  definition,
  value,
  onChange,
}) => {
  switch (definition.type) {
    case 'boolean':
      return (
        <BooleanCondition
          description={definition.description}
          label={definition.label}
          value={value as boolean | undefined}
          onChange={onChange}
        />
      );
    case 'sponsored_trial_nct_numbers':
      return (
        <NctIdListCondition
          shouldValidateNctFormat
          description={definition.description}
          label={definition.label}
          value={value as string[] | undefined}
          onChange={onChange}
        />
      );
    case 'sponsored_treatment_nct_numbers':
      return (
        <NctIdListCondition
          description={definition.description}
          label={definition.label}
          shouldValidateNctFormat={false}
          value={value as string[] | undefined}
          onChange={onChange}
        />
      );
    default:
      return null;
  }
};
